import { render, staticRenderFns } from "./Insurance.vue?vue&type=template&id=f507901e&"
import script from "./Insurance.vue?vue&type=script&setup=true&lang=js&"
export * from "./Insurance.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports